<div class="main-wrapper">
    <div class="top-box">
        <div class="timer-box">
            <div class="t-head">
                <p>Days</p>
                <p>Hours</p>
                <p>Min</p>
                <p>Sec</p>
            </div>
            <div class="count">
                <p>{{remainingDays}}</p>
                <span>:</span>
                <p>{{remainingHours}}</p>
                <span>:</span>
                <p>{{remainingMinutes}}</p>
                <span>:</span>
                <p>{{remainingSeconds}}</p>
            </div>
        </div>
        <div class="message-box">
            <p>{{showMessage}}</p>
        </div>
    </div>
    <div class="key-box">
        <label>Your 6 digit Key : </label>
        <span>{{_idKey}}</span>
    </div>
</div>
